import React, { Component } from 'react'
import Table from "../../../components/UI/Table/Table";
import { pendingTableColumns, DEFAULT_PAGE_SIZE, PENDING, completedTableColumns } from '../constant';
class TableView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: this.props.tasks
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.tasks !== prevProps.tasks) {
            this.setState({
                data: this.props.tasks
            })
        }
    }

    render() {
        return (
            <Table
                data={this.props.data.taskViewResponses}
                columns={ this.props.status === PENDING ? pendingTableColumns : completedTableColumns}
                defaultSorted={[
                    {
                        id: "taskId",
                        desc: false
                    }
                ]}
                noDataText="No cases found"
                multiSort={false}
                pages={this.props.data.numberOfPages}
                defaultPageSize={DEFAULT_PAGE_SIZE}
                showPagination={true}
                showPaginationTop={false}
                showPaginationBottom={true}
                manual  // this would indicate that server side pagination has been enabled 
                loading={this.props.loading}
                onPageChange={(pageIndex) => { // Called when the page index is changed by the user
                    this.setState({
                        currentPageIndex: pageIndex
                    });
                    this.props.onFetchPage(this.props.status, pageIndex, DEFAULT_PAGE_SIZE, this.state.sorted);
                }}
                onSortedChange={(newSorted, column, shiftKey) => { // Called when a sortable column header is clicked with the column itself and if the shiftkey was held. If the column is a pivoted column, 'column' will be an array of columns
                    this.setState({
                        sorted: newSorted[0]
                    });
                    this.props.onFetchPage(this.props.status, 0, DEFAULT_PAGE_SIZE, newSorted[0]);
                }}
            />
        )
    }
}

export default TableView
